<div class="toast toast-{{type}} flex align-items-center justify-content-between">
    <div class="flex align-items-start">
        <i [ngClass]="icon ? icon : 'fa-regular fa-circle-info'"></i>
        <p [innerHTML]="text"></p>
    </div>
    <p-button *ngIf="buttonTitle" label="{{ buttonTitle | translate }}" [routerLink]="buttonUrl" (click)="click()"></p-button>
</div>
